import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#chevron-left_svg__a)">
      <path
        fill="currentColor"
        d="M16 22c-.26 0-.51-.1-.71-.29l-9-9a.996.996 0 0 1 0-1.41l9-9.01A.996.996 0 1 1 16.7 3.7L8.41 12l8.29 8.29a.996.996 0 0 1-.71 1.7z"
      />
    </g>
    <defs>
      <clipPath id="chevron-left_svg__a">
        <path fill="#fff" d="M6 2h11v20H6z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChevronLeft;
